import { FC } from "react";
import { Text } from "@chakra-ui/react";
import { useNav } from "./useNav";

export const Phase: FC = () => {
  const { phase } = useNav();

  return (
    <Text textTransform="uppercase" variant="th-t2">
      {phase}
    </Text>
  );
};
